<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col sm="12">
				<b-card no-body class="p-2">
					<b-form @submit="onSearchSubmit" @reset="onReset" v-if="showSearch" inline>
						<h4 class="mr-4" cols="12">{{topiclist.CategoryName}}</h4>
						<b-input-group prepend="Title" class="my-1" cols="12">
							<b-form-input v-model="search.title" type="text"></b-form-input>
						</b-input-group>

						<b-button type="submit" variant="outline-primary" class="my-1 ml-sm-2">
							<i class="fa fa-search fa-fw fa-lg"></i>
						</b-button>

						<b-button type="reset" variant="secondary" class="my-1 ml-2">
							<i class="fa fa-refresh fa-fw fa-lg"></i>
						</b-button>

						<b-button variant="primary" class="ml-auto" @click="onAddClick" v-if="IsNewAllowed === true">
							<i class="fa fa-plus fa-fw fa-lg"></i>&nbsp;Add
						</b-button>
					</b-form>
					<div class="row">
						<div class="col-12 grid-view-container">
							<b-alert show variant="warning" v-if="topiclist.TotalRecordCount === 0">
								<strong>Nothing found!</strong>
							</b-alert>
							<div class="table-responsive" v-if="topiclist.Records && topiclist.TotalRecordCount > 0">
								<table class="table table-sm table-hover table-bordered mb-2">
									<thead class="bg-primary">
										<tr role="row">
											<th scope="col">{{topiclist.Headers[0].Title}}</th>
											<th scope="col">{{topiclist.Headers[1].Title}}</th>
											<th scope="col">{{topiclist.Headers[2].Title}}</th>
											<th scope="col" v-if="topiclist.Headers.length === 4"></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(record, recordkey) in topiclist.Records" v-bind:key="recordkey">
											<td
												v-for="(cell, columnkey) in record.Cells"
												v-bind:key="columnkey"
												v-if="topiclist.Headers[columnkey].IsHidden !== true"
											>
												<a
													v-if="columnkey == 0"
													href="javascript:void(0)"
													class="nav-link p-0 h6"
													@click="onRowClicked(record)"
												>
												<b-img :src="record.AvatarUrl" :width="50" :height="50" v-if="columnkey === 0" left class="mr-3"></b-img>
												{{cell.DisplayText}}
												</a>
												<template v-else>
													<b-badge
														v-if="topiclist.Headers[columnkey].IsStatusDisplay && topiclist.Headers[columnkey].IsStatusDisplay === true"
														:variant="getStatusClass(cell.DisplayText)"
														class="p-2"
													>
														<span>{{cell.DisplayText}}</span>
													</b-badge>
													<span v-else>{{cell.DisplayText}}</span>
												</template>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<nav v-if="topiclist.Pagination && topiclist.TotalRecordCount > 0">
								<ul class="pagination pagination-sm justify-content-end mb-0">
									<template v-if="topiclist.Pagination.CurrentPage === 1">
										<!-- First (disabled)-->
										<li class="page-item disabled">
											<a class="page-link" href="javascript:void(0)">First</a>
										</li>

										<!-- Previous (disabled)-->
										<li class="page-item disabled">
											<a class="page-link" href="javascript:void(0)" aria-label="Previous">
												<i class="fa fa-angle-double-left fa-fw"></i>
											</a>
										</li>
									</template>

									<template v-if="topiclist.Pagination.CurrentPage !== 1">
										<!-- First -->
										<li class="page-item">
											<a
												class="page-link page-link-grid-view"
												data-pageno="1"
												href="javascript:void(0)"
												@click="$emit('page_clicked', 1)"
											>First</a>
										</li>

										<!-- Previous -->
										<li class="page-item">
											<a
												class="page-link page-link-grid-view"
												href="javascript:void(0)"
												aria-label="Previous"
												@click="$emit('page_clicked', topiclist.Pagination.CurrentPage-1)"
											>
												<i class="fa fa-angle-double-left fa-fw"></i>
											</a>
										</li>
									</template>

									<template v-for="(page, key) in topiclist.Pagination.Pages">
										<li
											class="page-item active"
											v-if="topiclist.Pagination.CurrentPage === page"
											v-bind:key="key"
										>
											<a
												class="page-link page-link-grid-view"
												:data-pageno="page"
												href="javascript:void(0)"
											>{{page}}</a>
										</li>
										<li class="page-item" v-if="topiclist.Pagination.CurrentPage !== page" v-bind:key="key">
											<a
												class="page-link page-link-grid-view"
												:data-pageno="page"
												href="javascript:void(0)"
												@click="$emit('page_clicked', page)"
											>{{page}}</a>
										</li>
									</template>

									<template
										v-if="topiclist.Pagination.CurrentPage === topiclist.Pagination.PageCount || topiclist.Pagination.PageCount === 0"
									>
										<!-- Next (disabled) -->
										<li class="page-item disabled">
											<a class="page-link" href="javascript:void(0)" aria-label="Last">
												<i class="fa fa-angle-double-right fa-fw"></i>
											</a>
										</li>

										<!-- Last (disabled) -->
										<li class="page-item disabled">
											<a class="page-link" href="javascript:void(0)">Last</a>
										</li>
									</template>

									<template
										v-if="topiclist.Pagination.CurrentPage !== topiclist.Pagination.PageCount && topiclist.Pagination.PageCount > 0"
									>
										<!-- Next -->
										<li class="page-item">
											<a
												class="page-link page-link-grid-view"
												href="javascript:void(0)"
												aria-label="Last"
												@click="$emit('page_clicked', topiclist.Pagination.CurrentPage + 1)"
											>
												<i class="fa fa-angle-double-right fa-fw"></i>
											</a>
										</li>

										<!-- Last -->
										<li class="page-item">
											<a
												class="page-link page-link-grid-view"
												:data-pageno="topiclist.Pagination.PageCount"
												@click="$emit('page_clicked', topiclist.Pagination.PageCount)"
												href="javascript:void(0)"
											>Last</a>
										</li>
									</template>
								</ul>
							</nav>
						</div>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import VueAxios from "@/shared/axios-instance.js";

export default {
	name: "ForumTopics",
	components: {},
	data() {
		return {
			topiclist: {},
			search: {
				title: ""
			},
			pageno: 1,
			showSearch: true,
			IsAddAllowed: true
		};
	},
	created() {
		this.getlist();
	},
	methods: {
		onSearchSubmit(evt) {
			evt.preventDefault();
			this.pageno = 1;
			this.getlist();
		},
		onReset(evt) {
			evt.preventDefault();
			this.search.title = "";
			this.pageno = 1;
			/* Trick to reset/clear native browser form validation state */
			this.showSearch = false;
			this.$nextTick(() => {
				this.showSearch = true;
			});
			this.getlist();
		},
		onAddClick() {
			this.$router.push(`/forum/newtopic/${this.$route.params.categoryid}`);
		},
		onPageClicked(pageno) {
			this.pageno = pageno;
			this.getlist();
		},
		getlist() {
			VueAxios.get(
				`/ForumTopic/Get?categoryId=${
					this.$route.params.categoryid
				}&pageno=${this.pageno}&search=${this.search.title}`
			)
				.then(resp => {
					this.topiclist = resp.data;
				})
				.catch(err => {
					if (err.data && err.data.Message) {
						this.$snotify.error(err.data.Message, "Error");
					} else {
						console.log(err);
					}
				});
		},
		onRowClicked(record) {
			if (record.Cells.length === 4) {
				const status = record.Cells[3].DisplayText;
				if (status === "Pending") {
					this.$snotify.warning("This topic needs approval before viewing", "Not Approved");
					return;
				} else {
					this.$router.push(`/forum/topic/${this.$route.params.categoryid}/${record.EntityId}`);
				}
			}
			this.$router.push(`/forum/topic/${this.$route.params.categoryid}/${record.EntityId}`);
		},
		getStatusClass(status) {
      if (status === "Pending") {
        return "secondary";
      } else if (status === "Approved") {
        return "success";
      }
    }
	},
	computed: {
		IsNewAllowed() {
			return this.$myStore.getters.Permission_IsAllowed(
				"Forum",
				"IsPost"
			);
		}
	}
};
</script>
